import { FC } from 'react'
import { FlexContainer, MainContainer, Text3XL, TextXL } from '@reapit/elements'
import { cssMainErrorPage404Container } from './styles'

export const DisableAppForSafari: FC = () => {
  return (
    <MainContainer>
      <FlexContainer isFlexGrow1 isFlexAlignCenter isFlexJustifyCenter className={cssMainErrorPage404Container}>
        <Text3XL intent="secondary" className="el-pb4">
          This browser isn’t supported
        </Text3XL>
        <TextXL intent="secondary" className="el-pb8">
          Please switch to a supported browser such as Chrome or Firefox.
        </TextXL>
      </FlexContainer>
    </MainContainer>
  )
}
